/**
 * The Layout component is used to set the layout of the app and loads the component based on incoming url also it filters routes based on group and contact type
 *
 */

import React from "react";
import { routes } from "../../../routes";
import * as UserActions from "../../../common/user";
import * as emergencybroadcastActions from "../../../store/portal";
import { NotificationContainer } from "react-notifications";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as _ from "lodash";
import { Helmet } from "react-helmet";
import { Redirect, Route, Switch } from "react-router-dom";
import Footer from "./Footer";

class Layout extends React.Component {
  constructor(props) {
    super(props);
    // init state
    this.state = {
      crole: "",
      settings: {},
      filteredRoutes: [],
      is_loading: true,
    };
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */

  componentDidMount() {
    // filter tile's routes based on defined in 'tile_settings'
    // if route match with defined route in tile_settings, those routes can be accessed
    if (
      this.props.settings &&
      this.props.role &&
      this.props.user &&
      this.state.filteredRoutes.length === 0
    ) {
      const crole = this.props.role;
      // const orgUnit = this.props.orgUnit;
      const tile_settings = this.props.settings["tile_settings"];
      const filterdRoutes = [];
      routes.forEach((item, index) => {
        let path = item["path"];
        let path_match = false;
        if (
          path !== '/' &&
          path !== '/docusign' &&
          path !== '/docusignboarder' &&
          path !== '/docusignpk' &&
          path !== '/docusignPK2K12' &&
          path !== '/docusignpkkps' &&
          path !== '/docusignPreschools' &&
          path !== '/student-goals' &&
          path !== '/docusign_interview' &&
          path !== '/places/:slug' &&
          path !== '/places/:slug/:pageSlug' &&
          path !== '/key-learning-area' &&
          path !== '/key-learning-area/:id' &&
          path !== '/parent-dashboard' &&
          path !== '/new-students' &&
          path !== '/student-goals' &&
          path !== '/school-psychology-request' &&
          path !== '/metrics' &&
          path !== '/emergency-contacts'
        ) {
          _.find(tile_settings, function (o) {
            if (path.includes(o.url)) {
              path_match = true;
              return o;
            } else {
              path_match = false;
            }
          });
        } else {
          path_match = true;
        }
        if (path_match) {
          filterdRoutes.push(item);
        }
      });
      this.setState({
        is_loading: false,
        settings: this.props.settings,
        filteredRoutes: filterdRoutes,
        crole: crole,
      });
    }
  }

  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    // Get settings after receving schoolUid
    if (this.props.user !== nextProps.user) {
      // Get settings
      this.props.fetchSettings({
        token: nextProps.token,
        id: nextProps.user.schoolUid,
      });
    }
    // fetch emergency broadcasts after receving token
    if (this.props.token !== nextProps.token) {
      this.props.fetchEmegencyBroadcasts(nextProps.token);
    }
    // filter tile routes after receving settings
    if (this.props.settings !== nextProps.settings) {
      const crole = nextProps.role;
      const filterdRoutes = [];
      const tile_settings = nextProps.settings["tile_settings"];
      routes.forEach((item, index) => {
        let path = item["path"];
        let path_match = false;
        if (
          path !== '/' &&
          path !== '/docusign' &&
          path !== '/docusignboarder' &&
          path !== '/docusignpk' &&
          path !== '/docusignPK2K12' &&
          path !== '/docusignpkkps' &&
          path !== '/docusignPreschools' &&
          path !== '/student-goals' &&
          path !== '/docusign_interview' &&
          path !== '/places/:slug' &&
          path !== '/places/:slug/:pageSlug' &&
          path !== '/key-learning-area' &&
          path !== '/key-learning-area/:id' &&
          path !== '/parent-dashboard' &&
          path !== '/new-students' &&
          path !== '/student-goals' &&
          path !== '/school-psychology-request' &&
          path !== '/metrics'&& 
          path !== '/emergency-contacts'
        ) {
          _.find(tile_settings, function (o) {
            if (path.includes(o.url)) {
              path_match = true;
              return o;
            } else {
              path_match = false;
            }
          });
        } else {
          path_match = true;
        }
        if (path_match) {
          filterdRoutes.push(item);
        }
      });
      this.setState({
        filteredRoutes: filterdRoutes,
        crole: crole,
        settings: nextProps.settings,
        is_loading: false,
      });
    }
  }

  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    return (
      <div>
        {this.state.is_loading === true && <div>loading...</div>}
        {this.state.is_loading === false &&
          this.state.filteredRoutes.length > 0 && (
            <div>
              {this.props.emergencybroadcast &&
                this.props.emergencybroadcast.length > 0 &&
                this.props.emergencybroadcast[0].status && (
                  <div>
                    <div class="blink_me">
                      <marquee
                        scrolldelay="10"
                        scrollamount="10"
                        direction="left"
                      >
                        <h4>{this.props.emergencybroadcast[0].message}</h4>
                      </marquee>
                    </div>
                  </div>
                )}
              <Helmet>
                <link rel="icon" href={this.state.settings.favicon_icon} />
                {this.state.settings.domain === "places.plc.sydney" && (
                  <title>PLC Sydney PLACES</title>
                )}
                {this.state.settings.domain ===
                  "connect.plcarmidale.nsw.edu.au" && (
                  <title>PLC Armidale PLACES</title>
                )}
              </Helmet>
              <NotificationContainer />
              <Switch>
                {this.state.filteredRoutes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={(props) => <route.component {...props} />}
                    />
                  ) : null;
                })}
                <Redirect from="/" to="/" />
              </Switch>
              <Footer
                bgColor={this.props.settings.theme_colours.footer_colour}
                phone={this.props.settings.phoneNumber}
              />
            </div>
          )}
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */

function mapStateToProps(state, props) {
  return {
    token: state.user.cognito_data.token,
    role: state.user.cognito_data.role,
    orgUnit: state.user.cognito_data.orgUnit,
    user: state.user.user,
    settings: state.user.user
      ? state.settings.byId[state.user.user.schoolUid]
      : "",
    user_gropus: state.user.user.group_list,
    emergencybroadcast: Object.values(state.emergencybroadcast.byId),
  };
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(
    Object.assign({}, emergencybroadcastActions, UserActions),
    dispatch
  )
)(Layout);